import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SubPageLayout from '../../components/SubPageLayout';
import CampaignDetailContent from '../../components/campaigns/CampaignDetailContent';
import { useCampaignQuery } from '../../components/campaigns/useCampaignQuery';
import { campaignLabel } from '../../components/campaigns/campaignLabel';

// Mobile campaign detail (/mobile/campaigns/:id): same content as the
// dashboard page, inside the mobile app bar with "back".
const Campaign = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  // Same query as CampaignDetailContent (deduped by react-query), only for the title.
  const { data } = useCampaignQuery(id);

  return (
    <SubPageLayout title={campaignLabel(data) || t('campaigns.detailTitle')} onBack={() => navigate(-1)}>
      <CampaignDetailContent uuid={id} />
    </SubPageLayout>
  );
};

export default Campaign;
